import { render } from "./Role.vue?vue&type=template&id=6f89e4ff"
const script = {}

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__